import { render, staticRenderFns } from "./OppleAbilityPanel.vue?vue&type=template&id=4fb5a5cf"
import script from "./OppleAbilityPanel.vue?vue&type=script&lang=js"
export * from "./OppleAbilityPanel.vue?vue&type=script&lang=js"
import style0 from "./OppleAbilityPanel.vue?vue&type=style&index=0&id=4fb5a5cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports